export const GetSearchItem = async (userId: string, query: string) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/search/get_search_item`, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
			body: JSON.stringify({
				userId,
				query,
			})
		});
		
		const data = await response.json();
		if (response && response.status === 200 && data) {
			console.log("GetSearchItem data: ", data);
			return data;
		} else {
			//data && data.message && toast.error(data.message);
			return null;
		}
	} catch (e) {
		console.log(e);
	}
}
